"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/internal-payment-funding.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Finternal-payment-funding.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFundingInternalContextStripe3DsResult = exports.CardFundingInternalContextStripeOutcome = exports.CardFundingInternalContextStripeChargeMetadata = exports.CardFundingInternalContext = exports.FundingInternalPaymentContext = void 0;
const amount_1 = require("../common/amount");
const external_card_1 = require("../common/external-card");
const protobufPackage = 'com.step.common.proto';
function createBaseFundingInternalPaymentContext() {
    return { card: undefined };
}
exports.FundingInternalPaymentContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.card)) {
            message.card = exports.CardFundingInternalContext.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardFundingInternalContext.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.FundingInternalPaymentContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingInternalPaymentContext();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardFundingInternalContext.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBaseCardFundingInternalContext() {
    return {
        stripeChargeMetadata: undefined,
        stripeOutcome: undefined,
        needsReview: false,
        is3dsRequested: false,
        stripe3dsResult: undefined,
        provider: external_card_1.ExternalCardProvider.INVALID_PROVIDER,
        binNumber: '',
    };
}
exports.CardFundingInternalContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.stripeChargeMetadata)) {
            message.stripeChargeMetadata = exports.CardFundingInternalContextStripeChargeMetadata.fromJSON(object.stripeChargeMetadata);
        }
        if (isSet(object.stripeOutcome)) {
            message.stripeOutcome = exports.CardFundingInternalContextStripeOutcome.fromJSON(object.stripeOutcome);
        }
        if (isSet(object.needsReview)) {
            message.needsReview = globalThis.Boolean(object.needsReview);
        }
        if (isSet(object.is3dsRequested)) {
            message.is3dsRequested = globalThis.Boolean(object.is3dsRequested);
        }
        if (isSet(object.stripe3dsResult)) {
            message.stripe3dsResult = exports.CardFundingInternalContextStripe3DsResult.fromJSON(object.stripe3dsResult);
        }
        if (isSet(object.provider)) {
            message.provider = (0, external_card_1.externalCardProviderFromJSON)(object.provider);
        }
        if (isSet(object.binNumber)) {
            message.binNumber = globalThis.String(object.binNumber);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.stripeChargeMetadata !== undefined) {
            obj.stripeChargeMetadata = exports.CardFundingInternalContextStripeChargeMetadata.toJSON(message.stripeChargeMetadata);
        }
        if (message.stripeOutcome !== undefined) {
            obj.stripeOutcome = exports.CardFundingInternalContextStripeOutcome.toJSON(message.stripeOutcome);
        }
        if (message.needsReview !== undefined && message.needsReview !== false) {
            obj.needsReview = message.needsReview;
        }
        if (message.is3dsRequested !== undefined && message.is3dsRequested !== false) {
            obj.is3dsRequested = message.is3dsRequested;
        }
        if (message.stripe3dsResult !== undefined) {
            obj.stripe3dsResult = exports.CardFundingInternalContextStripe3DsResult.toJSON(message.stripe3dsResult);
        }
        if (message.provider !== undefined && message.provider !== external_card_1.ExternalCardProvider.INVALID_PROVIDER) {
            obj.provider = (0, external_card_1.externalCardProviderToJSON)(message.provider);
        }
        if (message.binNumber !== undefined && message.binNumber !== '') {
            obj.binNumber = message.binNumber;
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingInternalContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingInternalContext();
        message.stripeChargeMetadata =
            (object.stripeChargeMetadata !== undefined && object.stripeChargeMetadata !== null)
                ? exports.CardFundingInternalContextStripeChargeMetadata.fromPartial(object.stripeChargeMetadata)
                : undefined;
        message.stripeOutcome = (object.stripeOutcome !== undefined && object.stripeOutcome !== null)
            ? exports.CardFundingInternalContextStripeOutcome.fromPartial(object.stripeOutcome)
            : undefined;
        message.needsReview = object.needsReview ?? false;
        message.is3dsRequested = object.is3dsRequested ?? false;
        message.stripe3dsResult =
            (object.stripe3dsResult !== undefined && object.stripe3dsResult !== null)
                ? exports.CardFundingInternalContextStripe3DsResult.fromPartial(object.stripe3dsResult)
                : undefined;
        message.provider = object.provider ?? external_card_1.ExternalCardProvider.INVALID_PROVIDER;
        message.binNumber = object.binNumber ?? '';
        return message;
    },
};
function createBaseCardFundingInternalContextStripeChargeMetadata() {
    return {
        countUniqueCardZipCodes: 0,
        countSuccessfulCardsAdded: 0,
        countFailedCardsAdded: 0,
        cardZipCodesMatchScore: 0,
        nameMatchScore: 0,
        daysSinceFirstFunding: undefined,
        daysSinceFirstFundingThisCard: undefined,
        daysSinceMostRecentFunding: undefined,
        fundingTotal: undefined,
        fundingCount: undefined,
        kycToIpDistance: undefined,
        cardZipToIpDistance: undefined,
        cardZipToKycDistance: undefined,
        isScanned: false,
    };
}
exports.CardFundingInternalContextStripeChargeMetadata = {
    fromJSON(object) {
        const message = {
            countUniqueCardZipCodes: isSet(object.countUniqueCardZipCodes)
                ? globalThis.Number(object.countUniqueCardZipCodes)
                : 0,
            countSuccessfulCardsAdded: isSet(object.countSuccessfulCardsAdded)
                ? globalThis.Number(object.countSuccessfulCardsAdded)
                : 0,
            countFailedCardsAdded: isSet(object.countFailedCardsAdded)
                ? globalThis.Number(object.countFailedCardsAdded)
                : 0,
            cardZipCodesMatchScore: isSet(object.cardZipCodesMatchScore)
                ? globalThis.Number(object.cardZipCodesMatchScore)
                : 0,
            nameMatchScore: isSet(object.nameMatchScore) ? globalThis.Number(object.nameMatchScore) : 0,
        };
        if (isSet(object.daysSinceFirstFunding)) {
            message.daysSinceFirstFunding = Number(object.daysSinceFirstFunding);
        }
        if (isSet(object.daysSinceFirstFundingThisCard)) {
            message.daysSinceFirstFundingThisCard = Number(object.daysSinceFirstFundingThisCard);
        }
        if (isSet(object.daysSinceMostRecentFunding)) {
            message.daysSinceMostRecentFunding = Number(object.daysSinceMostRecentFunding);
        }
        if (isSet(object.fundingTotal)) {
            message.fundingTotal = amount_1.Amount.fromJSON(object.fundingTotal);
        }
        if (isSet(object.fundingCount)) {
            message.fundingCount = Number(object.fundingCount);
        }
        if (isSet(object.kycToIpDistance)) {
            message.kycToIpDistance = Number(object.kycToIpDistance);
        }
        if (isSet(object.cardZipToIpDistance)) {
            message.cardZipToIpDistance = Number(object.cardZipToIpDistance);
        }
        if (isSet(object.cardZipToKycDistance)) {
            message.cardZipToKycDistance = Number(object.cardZipToKycDistance);
        }
        if (isSet(object.isScanned)) {
            message.isScanned = globalThis.Boolean(object.isScanned);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.countUniqueCardZipCodes !== 0) {
            obj.countUniqueCardZipCodes = Math.round(message.countUniqueCardZipCodes);
        }
        if (message.countSuccessfulCardsAdded !== 0) {
            obj.countSuccessfulCardsAdded = Math.round(message.countSuccessfulCardsAdded);
        }
        if (message.countFailedCardsAdded !== 0) {
            obj.countFailedCardsAdded = Math.round(message.countFailedCardsAdded);
        }
        if (message.cardZipCodesMatchScore !== 0) {
            obj.cardZipCodesMatchScore = message.cardZipCodesMatchScore;
        }
        if (message.nameMatchScore !== 0) {
            obj.nameMatchScore = message.nameMatchScore;
        }
        if (message.daysSinceFirstFunding !== undefined) {
            obj.daysSinceFirstFunding = message.daysSinceFirstFunding;
        }
        if (message.daysSinceFirstFundingThisCard !== undefined) {
            obj.daysSinceFirstFundingThisCard = message.daysSinceFirstFundingThisCard;
        }
        if (message.daysSinceMostRecentFunding !== undefined) {
            obj.daysSinceMostRecentFunding = message.daysSinceMostRecentFunding;
        }
        if (message.fundingTotal !== undefined) {
            obj.fundingTotal = amount_1.Amount.toJSON(message.fundingTotal);
        }
        if (message.fundingCount !== undefined) {
            obj.fundingCount = message.fundingCount;
        }
        if (message.kycToIpDistance !== undefined) {
            obj.kycToIpDistance = message.kycToIpDistance;
        }
        if (message.cardZipToIpDistance !== undefined) {
            obj.cardZipToIpDistance = message.cardZipToIpDistance;
        }
        if (message.cardZipToKycDistance !== undefined) {
            obj.cardZipToKycDistance = message.cardZipToKycDistance;
        }
        if (message.isScanned !== undefined && message.isScanned !== false) {
            obj.isScanned = message.isScanned;
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingInternalContextStripeChargeMetadata.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingInternalContextStripeChargeMetadata();
        message.countUniqueCardZipCodes = object.countUniqueCardZipCodes ?? 0;
        message.countSuccessfulCardsAdded = object.countSuccessfulCardsAdded ?? 0;
        message.countFailedCardsAdded = object.countFailedCardsAdded ?? 0;
        message.cardZipCodesMatchScore = object.cardZipCodesMatchScore ?? 0;
        message.nameMatchScore = object.nameMatchScore ?? 0;
        message.daysSinceFirstFunding = object.daysSinceFirstFunding ?? undefined;
        message.daysSinceFirstFundingThisCard = object.daysSinceFirstFundingThisCard ?? undefined;
        message.daysSinceMostRecentFunding = object.daysSinceMostRecentFunding ?? undefined;
        message.fundingTotal = (object.fundingTotal !== undefined && object.fundingTotal !== null)
            ? amount_1.Amount.fromPartial(object.fundingTotal)
            : undefined;
        message.fundingCount = object.fundingCount ?? undefined;
        message.kycToIpDistance = object.kycToIpDistance ?? undefined;
        message.cardZipToIpDistance = object.cardZipToIpDistance ?? undefined;
        message.cardZipToKycDistance = object.cardZipToKycDistance ?? undefined;
        message.isScanned = object.isScanned ?? false;
        return message;
    },
};
function createBaseCardFundingInternalContextStripeOutcome() {
    return { networkStatus: '', reason: '', riskLevel: '', riskScore: 0, type: '', rule: '' };
}
exports.CardFundingInternalContextStripeOutcome = {
    fromJSON(object) {
        const message = {
            networkStatus: isSet(object.networkStatus) ? globalThis.String(object.networkStatus) : '',
            riskLevel: isSet(object.riskLevel) ? globalThis.String(object.riskLevel) : '',
            type: isSet(object.type) ? globalThis.String(object.type) : '',
        };
        if (isSet(object.reason)) {
            message.reason = globalThis.String(object.reason);
        }
        if (isSet(object.riskScore)) {
            message.riskScore = globalThis.Number(object.riskScore);
        }
        if (isSet(object.rule)) {
            message.rule = globalThis.String(object.rule);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.networkStatus !== '') {
            obj.networkStatus = message.networkStatus;
        }
        if (message.reason !== undefined && message.reason !== '') {
            obj.reason = message.reason;
        }
        if (message.riskLevel !== '') {
            obj.riskLevel = message.riskLevel;
        }
        if (message.riskScore !== undefined && message.riskScore !== 0) {
            obj.riskScore = Math.round(message.riskScore);
        }
        if (message.type !== '') {
            obj.type = message.type;
        }
        if (message.rule !== undefined && message.rule !== '') {
            obj.rule = message.rule;
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingInternalContextStripeOutcome.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingInternalContextStripeOutcome();
        message.networkStatus = object.networkStatus ?? '';
        message.reason = object.reason ?? '';
        message.riskLevel = object.riskLevel ?? '';
        message.riskScore = object.riskScore ?? 0;
        message.type = object.type ?? '';
        message.rule = object.rule ?? '';
        return message;
    },
};
function createBaseCardFundingInternalContextStripe3DsResult() {
    return { authenticationFlow: '', result: '', resultReason: '', version: '' };
}
exports.CardFundingInternalContextStripe3DsResult = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.authenticationFlow)) {
            message.authenticationFlow = globalThis.String(object.authenticationFlow);
        }
        if (isSet(object.result)) {
            message.result = globalThis.String(object.result);
        }
        if (isSet(object.resultReason)) {
            message.resultReason = globalThis.String(object.resultReason);
        }
        if (isSet(object.version)) {
            message.version = globalThis.String(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.authenticationFlow !== undefined && message.authenticationFlow !== '') {
            obj.authenticationFlow = message.authenticationFlow;
        }
        if (message.result !== undefined && message.result !== '') {
            obj.result = message.result;
        }
        if (message.resultReason !== undefined && message.resultReason !== '') {
            obj.resultReason = message.resultReason;
        }
        if (message.version !== undefined && message.version !== '') {
            obj.version = message.version;
        }
        return obj;
    },
    create(base) {
        return exports.CardFundingInternalContextStripe3DsResult.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardFundingInternalContextStripe3DsResult();
        message.authenticationFlow = object.authenticationFlow ?? '';
        message.result = object.result ?? '';
        message.resultReason = object.resultReason ?? '';
        message.version = object.version ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=internal-payment-funding.js.map